import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getReportById, updateReport } from '../../actions/report.action';
import style from './Submission.module.css';
import { Oval } from 'react-loader-spinner';
import Footer from '../../Components/Footer/Footer';
import { toast } from 'react-toastify';
import axios from 'axios';

const Submission = () => {
  const dispatch = useDispatch();
  const path = window.location.pathname;
  const reportId = path.split('/')[2];
  const userId = path.split('/')[3];

  const user = JSON.parse(localStorage.getItem('curUser'));
  const [status, setStatus] = useState('');
  const [comment, setComment] = useState('');

  const handleSubmit = async (e, comment, reportid) => {
    e.preventDefault();
    try {
      axios
        .put(
          `report/comment/${user.user._id}`,
          { text: comment, reportid },
          {
            headers: { 'Access-Control-Allow-Origin': '*' },
            withCredentials: true,
          }
        )
        .then((_) => {
          window.location.reload();
        });
      setComment('');
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    dispatch(getReportById(reportId, userId));
  }, []);

  const { report, loading, success } = useSelector((state) => {
    return state.getReportByIdReducer;
  });

  const updatedReportState = useSelector((state) => state.updateReportReducer);
  if (!updatedReportState.loading && updatedReportState.success) {
    toast.success('Update Successful!');
  } else {
    toast.error(updatedReportState.message);
  }

  const [check, setCheck] = useState(true);
  if (!loading && success && check) {
    setCheck(false);
  }

  return !loading && success ? (
    <>
      <div className={style.Submission}>
        <h1>Details</h1>
        {(user && user.user.isAdmin) || user.user.isOrg ? (
          <select
            value={status === '' ? report.status : status}
            onChange={(e) => {
              setStatus(e.target.value);
              dispatch(updateReport(report._id, e.target.value));
            }}
            style={{ marginTop: '20px' }}
            className='minimal'
          >
            <option>Pending</option>
            <option>Under review</option>
            <option>Approved</option>
          </select>
        ) : null}
        <div className={style.Report}>
          <p>Report ID</p>
          {report._id}
        </div>
        <div className={style.Status}>
          <p>Status</p>
          <div className={style.Status_info}>{report.status}</div>
        </div>
        <div className={style.Severity}>
          <p>Severity</p>
          <div className={style.Severity_info}>{report.severity}</div>
        </div>
        <div className={style.Target}>
          <p>Target</p>
          {report.target.target}
          <div className={style.Target_type}>{report.target.type}</div>
        </div>
        <div className={style.Description}>
          <p>Description</p>
          <div
            dangerouslySetInnerHTML={{
              __html: `${report.report.desc}`,
            }}
          />
        </div>
        {report.report.poc !== '' ? (
          <div className={style.Description}>
            <p>Proof of concept</p>
            <div
              dangerouslySetInnerHTML={{
                __html: `${report.report.poc}`,
              }}
            />
          </div>
        ) : null}
        <div className={style.UPI}>
          <p>Payment Details</p>
          <div className={style.upi}>
            <b>Name : </b>
            {report.payment.name}
          </div>
          <div className={style.upi}>
            <b>IFSC : </b>
            {report.payment.ifsc}
          </div>
          <div className={style.upi}>
            <b> Account Number : </b>
            {report.payment.account_no}
          </div>
        </div>
        <div className={style.comment}>
          <p>Comments</p>
          <div>
            {report.comments.map((comment) => {
              return (
                <div key={comment._id} className={style.commentBox}>
                  <p>
                    <span className={style.name}>
                      {comment.postedBy.userId === user.user._id
                        ? 'You'
                        : `${comment.postedBy.name}`}
                      {comment.postedBy.userId !== user.user._id && (
                        comment.postedBy.isOrg
                          ? ' (Org)'
                          : comment.postedBy.isAdmin
                          ? ' (Admin)'
                          : ''
                      )}
                    </span>{' '}
                    <span style={{ fontSize: '12px' }}>
                      {comment.postedBy.createdAt.split('T')[0]}
                    </span>
                  </p>
                  <p>{comment.text}</p>
                </div>
              );
            })}
          </div>
          <div className={style.textBox}>
            <input
              type='text'
              placeholder='Add a comment...'
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
            {comment.length > 0 && (
              <div
                className={style.Button}
                onClick={(e) => handleSubmit(e, comment, report._id)}
              >
                Submit
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  ) : (
    <div className={style.Center}>
      <Oval
        ariaLabel='loading-indicator'
        height={80}
        width={80}
        strokeWidth={5}
        color='white'
        secondaryColor='purple'
      />
    </div>
  );
};

export default Submission;
